import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import ms from './locales/ms';
import zh from './locales/zh';

// import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const detectorOptions = {
  // order and from where user language should be detected
  order: ['localStorage'],

  // keys or params to lookup language from
  lookupLocalStorage: 'i18nextLng',

  // cache user language on
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
};

i18n
// pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(LanguageDetector)
// init i18next
  .init({
    detection: detectorOptions,
    resources: {
      en,
      ms,
      zh,
    },
    fallbackLng: 'en',
    debug: process.env.APP_ENV === 'local',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

// For prod always default to English for now, until ms and zh are ready
if(process.env.APP_ENV === 'production') {
  i18n.changeLanguage('en');
}

export default i18n;